@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.read-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: default;
  border-radius: 3px;
}

.pencil-icon {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: @space-4;
  color: var(--blue-600);
  font-size: 12px;
  opacity: 0;
  pointer-events: none;
}

.read-wrapper:hover .pencil-icon {
  opacity: 1;
}

.edit-wrapper {
  display: inline-flex;
  align-items: center;
}
